// Styles
import './VCalendarWeeklyByEntity.sass';

// Directives
import Resize from 'vuetify/lib/directives/resize';

import VCalendarWeekly from 'vuetify/lib/components/VCalendar/VCalendarWeekly';

import { convertToUnit, getSlot } from 'vuetify/lib/util/helpers';

import baseProps from 'vuetify/lib/components/VCalendar/util/props';
import props from './util/props';
import {
  getDayIdentifier,
  parseTimestamp
} from 'vuetify/lib/components/VCalendar/util/timestamp';
import { VTooltip, VIcon, VChip } from 'vuetify/lib';
import moment from 'moment';
import i18n from '@/i18n';
export default {
  name: 'v-calendar-weekly-by-entity',

  extends: VCalendarWeekly,

  props: {
    ...props.entity,
    eventHeight: baseProps.events.eventHeight
  },

  directives: {
    Resize
  },

  data: () => ({
    scrollPush: 0,
    bodyHeight: null
  }),

  computed: {
    parsedSelectedDays() {
      const selectedDaysByEntity = {};

      this.selectedDays.forEach(day => {
        const date = day[this.selectedDayDate];
        const entityId = day[this.selectedDayEntityId];

        if (!selectedDaysByEntity[entityId]) {
          selectedDaysByEntity[entityId] = [];
        }

        selectedDaysByEntity[entityId].push(parseTimestamp(date));
      });

      return selectedDaysByEntity;
    },
    staticClass() {
      return 'v-calendar-weekly-entities';
    },
    classes() {
      return {
        ...this.themeClasses,
        'v-calendar-weekly-entities_height-auto': !this.parsedEntityHeight
      };
    },
    parsedEntitiesCount() {
      return this.entities.length;
    },
    parsedPaddingDay() {
      return this.paddingDay ? parseFloat(this.paddingDay) : null;
    },
    parsedEntityWidth() {
      return this.entityWidth ? parseFloat(this.entityWidth) : null;
    },
    parsedEntityHeight() {
      return this.entityHeight ? parseFloat(this.entityHeight) : null;
    },
    entityFormatter() {
      if (this.entityFormat) {
        return this.entityFormat;
      }

      return entity => {
        if (typeof entity === 'object' && entity !== null) {
          const firstName = entity.first_name || '';
          const lastName = entity.last_name || '';

          return `${firstName} ${lastName}`.trim();
        }

        return entity;
      };
    }
  },

  mounted() {
    this.init();
  },

  watch: {
    parsedEntitiesCount: 'calcBodyHeight'
  },

  methods: {
    init() {
      this.$nextTick(this.onResize);
    },

    showEntityLabelDefault() {
      return true;
    },

    onResize() {
      this.scrollPush = this.getScrollPush();
    },

    calcBodyHeight() {
      if (this.parsedEntityHeight === null) {
        return null;
      }

      let height = this.parsedEntitiesCount * this.parsedEntityHeight;
      const weekHeads = this.$refs.weekHead;

      if (!weekHeads || !weekHeads.forEach) {
        return height;
      }

      weekHeads.forEach(weekHead => {
        height += weekHead.offsetHeight;
      });

      return height;
    },

    getScrollPush() {
      const area = this.$refs.scrollArea;
      const pane = this.$refs.pane;
      return area && pane ? area.offsetWidth - pane.offsetWidth : 0;
    },

    genBody() {
      return this.$createElement(
        'div',
        {
          staticClass: 'v-calendar-weekly-entities__body'
        },
        [this.genScrollArea()]
      );
    },

    genScrollArea() {
      return this.$createElement(
        'div',
        {
          ref: 'scrollArea',
          staticClass: 'v-calendar-weekly-entities__scroll-area'
        },
        [this.genPane()]
      );
    },

    genPane() {
      return this.$createElement(
        'div',
        {
          ref: 'pane',
          staticClass: 'v-calendar-weekly-entities__pane',
          style: {
            height: convertToUnit(this.bodyHeight)
          }
        },
        [this.genWeeksContainer()]
      );
    },

    genWeeksContainer() {
      return this.$createElement(
        'div',
        {
          staticClass: 'v-calendar-weekly-entities__weeks-container'
        },
        this.genWeeks()
      );
    },

    genHead() {
      return this.$createElement(
        'div',
        {
          style: {
            marginRight: this.scrollPush + 'px'
          },
          staticClass: 'v-calendar-weekly-entities__head'
        },
        [this.genHeadEntities(), ...this.genHeadDays()]
      );
    },

    genHeadEntities() {
      const width = convertToUnit(this.parsedEntityWidth);
      return this.$createElement(
        'div',
        {
          staticClass: 'v-calendar-weekly-entities__entities-head',
          style: {
            width
          }
        },
        getSlot(this, 'entities-head')
      );
    },

    genHeadDays() {
      return this.todayWeek.map(this.genHeadDay);
    },

    genHeadDay(day, index) {
      const outside = this.isOutside(this.days[index]);
      const color = day.present ? this.color : undefined;
      return this.$createElement(
        'div',
        this.setTextColor(color, {
          key: day.date,
          staticClass: 'v-calendar-weekly-entities__head-weekday',
          class: this.getRelativeClasses(day, outside)
        }),
        this.weekdayFormatter(day, this.shortWeekdays)
      );
    },

    genWeeks() {
      const days = this.days;
      const weekDays = this.parsedWeekdays.length;
      const weeks = [];

      for (let i = 0; i < days.length; i += weekDays) {
        weeks.push(
          this.getWeekByEntities(
            days.slice(i, i + weekDays),
            this.getWeekNumber(days[i])
          )
        );
      }

      return weeks;
    },

    getWeekByEntities(week, weekNumber) {
      const entities = this.entities;
      const entitiesWeeks = [];

      for (let i = 0; i < entities.length; i++) {
        entitiesWeeks.push(this.genWeek(week, entities[i]));
      }

      return [this.genWeekHead(week, weekNumber), ...entitiesWeeks];
    },

    genWeekHead(week, weekNumber) {
      const weekHeadNodes = week.map(this.genWeekHeadDay);

      return this.$createElement(
        'div',
        {
          key: `week-head-${week[0].date}`,
          staticClass: 'v-calendar-weekly-entities__week-head',
          ref: 'weekHead',
          refInFor: true
        },
        [this.genWeekEntitiesHead(week, weekNumber), ...weekHeadNodes]
      );
    },

    genWeekEntitiesHead(week, weekNumber) {
      const width = convertToUnit(this.parsedEntityWidth);
      const slot = getSlot(this, 'week-entities-head', () => ({
        week
      }));

      return this.$createElement(
        'div',
        {
          style: {
            width
          },
          key: `week-entity-head-${week[0].date}`,
          staticClass: 'v-calendar-weekly-entities__week-entities-head'
        },
        slot || [
          this.genTitle(),
          this.showWeek ? this.genWeekNumber(weekNumber) : null
        ]
      );
    },

    genWeek(week, entity) {
      const entityId = entity[this.entityId];
      const weekNodes = week.map((day, index) =>
        this.genDay(day, index, week, entity)
      );

      return this.$createElement(
        'div',
        {
          key: `${entityId}-${week[0].date}`,
          staticClass: 'v-calendar-weekly-entities__week'
        },
        [this.genEntityLabel(entity), ...weekNodes]
      );
    },

    genDay(day, index, week, entity) {
      let isDragover = false;
      const onDragEnter = e => {
        e.preventDefault();
        isDragover = true;
        e.currentTarget.classList.add(
          'v-calendar-weekly-entities__day--dragover'
        );
      };
      const onDragLeave = e => {
        isDragover = false;
        e.currentTarget.classList.remove(
          'v-calendar-weekly-entities__day--dragover'
        );
      };

      const onDrop = e => {
        onDragLeave(e);
        e.preventDefault();
        const eventData = JSON.parse(
          e.dataTransfer.getData('application/json')
        );
        this.$emit('event-drop', { event: eventData, day, entity });
      };

      const outside = this.isOutside(day);
      const entityId = entity[this.entityId];
      const height = convertToUnit(this.parsedEntityHeight);
      const padding = convertToUnit(this.parsedPaddingDay);
      const isSelectedDay = this.isSelectedDay(entityId, day);
      const vacationDay = this.getVacationDay(entityId, day);
      let style = {
        height,
        padding
      };

      if (vacationDay) {
        style = {
          ...style,
          'background-size': 'cover',
          background: `repeating-linear-gradient(30deg, ${vacationDay.status
            .color ||
            'lightgrey'} 0, transparent 1px, transparent .25em, ${vacationDay
            .status.color || 'lightgrey'} calc(.25em + 1px), ${vacationDay
            .status.color || 'lightgrey'} .5em) no-repeat fixed center`
        };
      }

      let item = this.$createElement(
        'div',
        {
          key: `${entityId}-${day.date}`,
          staticClass: 'v-calendar-weekly-entities__day',
          class: {
            ...this.getRelativeClasses(day, outside),
            'v-calendar-weekly-entities__day_selected': isSelectedDay
          },
          style: { ...style },
          attrs: {
            'data-entity': entityId
          },
          on: {
            ...this.getDefaultMouseEventHandlers(':day', _e => ({
              day,
              entity
            })),
            dragenter: onDragEnter,
            dragover: e => {
              e.preventDefault();
              if (!isDragover) onDragEnter(e);
            },
            dragleave: onDragLeave,
            drop: onDrop
          }
        },
        [
          ...(getSlot(this, 'day-entity', () => ({
            outside,
            index,
            week,
            entity,
            ...day
          })) || [])
        ]
      );

      return item;
    },

    genEntityLabel(entity) {
      const width = convertToUnit(this.parsedEntityWidth);
      const height = convertToUnit(this.parsedEntityHeight);
      const shower = this.showEntityLabel || this.showEntityLabelDefault;
      const show = shower(entity);
      const label = show ? this.entityFormatter(entity) : undefined;
      const entityId = entity[this.entityId];

      return this.$createElement(
        'div',
        {
          key: entityId,
          staticClass: 'v-calendar-weekly-entities__entity',
          style: {
            width,
            height
          }
        },
        [
          this.$createElement(
            'div',
            {
              staticClass: 'v-calendar-weekly-entities__entity-text'
            },
            getSlot(this, 'entity-label', entity) || label
          )
        ]
      );
    },

    genWeekHeadDay(day) {
      const outside = this.isOutside(day);

      let holiday = this.holidays.find(el => el.date === day.date);
      if (holiday === undefined) {
        return this.genWeekBasicHeadDay(day, outside);
      } else {
        return this.genWeekHolidayHeadDay(day, outside, holiday);
      }
    },

    genWeekBasicHeadDay(day, outside) {
      return this.$createElement(
        'div',
        {
          staticClass: 'v-calendar-weekly-entities__head-weekday',
          class: this.getRelativeClasses(day, outside)
        },
        [this.genDayLabel(day)]
      );
    },

    genWeekHolidayHeadDay(day, outside, holiday) {
      if (holiday.is_all_regions) {
        let span = this.$createElement('span', {}, holiday.title);
        let tooltip = this.$createElement(
          VTooltip,
          {
            props: {
              top: true
            },
            scopedSlots: {
              activator: ({ on }) => {
                return this.$createElement(
                  'div',
                  {
                    attrs: {},
                    on: on
                  },
                  [this.genDayLabel(day)]
                );
              }
            }
          },
          [span]
        );

        return this.$createElement(
          'div',
          {
            staticClass:
              'v-calendar-weekly-entities__head-weekday v-calendar-holiday',
            class: this.getRelativeClasses(day, outside)
          },
          [tooltip]
        );
      }

      return this.$createElement(
        'div',
        {
          staticClass: 'v-calendar-weekly-entities__head-weekday',
          class: this.getRelativeClasses(day, outside)
        },
        [this.genDayLabelButton(day), this.getTooltipHolidays(holiday)]
      );
    },

    getTooltipHolidays(holiday) {
      let icon = this.$createElement(VIcon, {
        props: {
          color: 'alert'
        },
        staticClass: 'v-calendar-holiday-icon',
        domProps: {
          innerHTML: 'mdi-information-variant-circle'
        }
      });
      let label = this.$createElement('div', {}, `${i18n.t('HOLIDAY.ITEMS')}:`);

      let chips = holiday.regions.map(region => {
        return this.$createElement(VChip, {
          props: {
            small: true
          },
          staticClass: 'mt-2 mr-2',
          domProps: {
            innerHTML: region.name
          }
        });
      });

      let group = this.$createElement(
        'div',
        {
          style: {
            maxWidth: '300px'
          }
        },
        [chips]
      );

      return this.$createElement(
        VTooltip,
        {
          props: {
            right: true
          },
          scopedSlots: {
            activator: ({ on }) => {
              return this.$createElement(
                'span',
                {
                  attrs: {},
                  on: on
                },
                [icon]
              );
            }
          }
        },
        [label, group]
      );
    },

    genDayLabel(day) {
      return this.$createElement(
        'div',
        {
          staticClass: 'v-calendar-weekly-entities__day-label'
        },
        getSlot(this, 'day-label', day) || [this.genDayLabelButton(day)]
      );
    },

    genTitle() {
      return this.$createElement(
        'div',
        {
          staticClass: 'v-calendar-weekly-entities__title'
        },
        this.$parent.title
      );
    },

    genWeekNumber(weekNumber) {
      return this.$createElement(
        'div',
        {
          staticClass: 'v-calendar-weekly-entities__weeknumber'
        },
        [this.$createElement('small', String(weekNumber))]
      );
    },

    getVacationDay(entityId, day) {
      return this.requestedVacations.find(
        el =>
          el.employee_id === entityId &&
          moment(day.date).isBetween(el.date_from, el.date_to, undefined, '[]')
      );
    },

    isSelectedDay(entityId, day) {
      const entitySelectedDays = this.parsedSelectedDays[entityId];

      if (!entitySelectedDays) {
        return false;
      }

      const dayIdentifier = getDayIdentifier(day);

      return entitySelectedDays.some(
        selectedDay => getDayIdentifier(selectedDay) === dayIdentifier
      );
    }
  },

  render(h) {
    return h(
      'div',
      {
        staticClass: this.staticClass,
        class: this.classes
      },
      [!this.hideHeader ? this.genHead() : '', this.genBody()]
    );
  }
};
